import React, { useEffect, useState } from "react";
import { Modal, Form, Select, DatePicker, message } from "antd";
import { visibleModalExportarFormularioAtom } from "../../ColaboradorListarStore";
import { useAtom } from "jotai";
import { FormularioService } from "services/FormularioService";
import { LoginService } from "services/LoginService";
import { saveAs } from "file-saver";
import moment from "moment";

const ModalReingreso = () => {
	const [visible, setVisible] = useAtom(visibleModalExportarFormularioAtom);
	const [formularios, setFormularios] = useState([]);
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		const cargaInicial = async () => {
			try {
				const response = await FormularioService.listarPorUsuario(LoginService.getUsuarioAutenticado().login);
				setFormularios(response);
			} catch (error) {
				console.error(error);
			}
		};
		cargaInicial();
	}, []);

	const onClickBtnExportar = () => {
		form.validateFields()
			.then(async (values) => {
				setLoading(true);
				try {
					values.periodo = values.periodo != null ? moment(values.periodo).format("MM/YYYY") : null;

					const response = await FormularioService.exportarDatos(values);
					saveAs(response.data, response.headers.filename);
					setVisible(false);
				} catch (error) {
					console.error(error);
					message.error("Ocurrió un error al exportar los datos del formulario");
				} finally {
					setLoading(false);
				}
			})
			.catch((info) => {
				console.log("Validate Failed:", info);
			});
	};

	return (
		<Modal
			title="Exportar Formulario"
			open={visible}
			okText="Exportar"
			okButtonProps={{ loading }}
			cancelButtonProps={{ disabled: loading }}
			onOk={onClickBtnExportar}
			onCancel={() => !loading && setVisible(false)}
			maskClosable={false}
			keyboard={!loading}
			closable={!loading}
			confirmLoading={loading}
			destroyOnClose
		>
			<Form form={form} autoComplete="off" layout="vertical">
				<Form.Item
					label="Formulario"
					name="formularioId"
					rules={[{ required: true, message: "Seleccione el formulario" }]}
				>
					<Select
						showSearch
						placeholder="Selecciona el formulario"
						filterOption={(input, option) =>
							option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
						}
					// onChange={onChangeFormulario}
					>
						{formularios.length > 0 &&
							formularios.map((formulario) => {
								return (
									<Select.Option key={formulario.id} value={formulario.id}>
										{formulario.nombre}
									</Select.Option>
								);
							})}
					</Select>
				</Form.Item>
				<Form.Item label="Periodo" name="periodo">
					<DatePicker picker="month" format="MM/YYYY" style={{ width: "50%" }} />
				</Form.Item>
			</Form>
		</Modal>
	);
};
export default ModalReingreso;
